import { ChevronLeft, ChevronRight, Palette } from "lucide-react";

/**
 * Top toolbar over the roster grid:
 * - Layout picker button (shows current layout name)
 * - Period nav (◀ Week 1 of 4 ▶) for week/month views
 * - Right-side info label that changes per view (e.g. "12 days total" / "NSW Police HWP layout")
 */
const RosterViewToolbar = ({
  calendarView,
  currentLayout,
  onOpenLayoutPicker,
  weekOffset,
  maxOffset,
  onPrev,
  onNext,
  viewLabel,
  dates,
  shifts,
}) => {
  const showPeriodNav = !["full", "police", "timeline", "heatmap", "daycards"].includes(
    calendarView
  );

  return (
    <div
      className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 border-b-0 px-4 py-3 flex items-center justify-between"
      data-testid="calendar-view-bar"
    >
      <button
        onClick={onOpenLayoutPicker}
        className="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded bg-zinc-100 dark:bg-zinc-800 text-zinc-700 dark:text-zinc-200 hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-colors border border-transparent hover:border-zinc-300 dark:hover:border-zinc-600"
        data-testid="open-layout-picker-btn"
      >
        <Palette className="w-3.5 h-3.5" />
        <span>
          Layout: <span className="font-semibold">{currentLayout.name}</span>
        </span>
      </button>

      {showPeriodNav && (
        <div className="flex items-center gap-3">
          <button
            onClick={onPrev}
            disabled={weekOffset === 0}
            className="p-1 rounded hover:bg-zinc-100 dark:hover:bg-zinc-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            data-testid="prev-period"
          >
            <ChevronLeft className="w-4 h-4 text-zinc-600 dark:text-zinc-400" />
          </button>
          <span className="text-xs font-medium text-zinc-700 dark:text-zinc-300 min-w-[140px] text-center tabular-nums">
            {viewLabel}
          </span>
          <button
            onClick={onNext}
            disabled={weekOffset >= maxOffset}
            className="p-1 rounded hover:bg-zinc-100 dark:hover:bg-zinc-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            data-testid="next-period"
          >
            <ChevronRight className="w-4 h-4 text-zinc-600 dark:text-zinc-400" />
          </button>
        </div>
      )}

      {calendarView === "full" && (
        <span className="text-xs text-zinc-500 dark:text-zinc-400">
          {dates.length} days total
        </span>
      )}
      {calendarView === "police" && (
        <span className="text-xs text-zinc-500 dark:text-zinc-400">
          NSW Police HWP layout · {dates.length} days
        </span>
      )}
      {calendarView === "timeline" && (
        <span className="text-xs text-zinc-500 dark:text-zinc-400">
          Timeline · hour-by-hour bars
        </span>
      )}
      {calendarView === "heatmap" && (
        <span className="text-xs text-zinc-500 dark:text-zinc-400">
          Coverage heatmap · {shifts.length} shifts × {dates.length} days
        </span>
      )}
      {calendarView === "daycards" && (
        <span className="text-xs text-zinc-500 dark:text-zinc-400">
          Day cards · select a date below
        </span>
      )}
    </div>
  );
};

export default RosterViewToolbar;
